import msdyn365Commerce, * as Msdyn365 from '@msdyn365-commerce/core';
import fetch from 'node-fetch';
import { IRegisterSubmitPayload } from '../modules/lxs-register/lxs-register.data';

export interface ISubmitRegisterRequestResponse {
    success: boolean;
    message?: string;
    data?: { [key: string]: unknown };
}

export class SubmitRegisterRequestInput implements Msdyn365.IActionInput {
    public getCacheKey = () => 'RegisterSubmitRequestInput';
    public getCacheObjectType = () => 'RegisterSubmitRequestInput';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

const createInput = (_args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new SubmitRegisterRequestInput();
};

async function action(_input: SubmitRegisterRequestInput, ctx: Msdyn365.IActionContext): Promise<ISubmitRegisterRequestResponse> {
    const requestBody = (ctx.requestContext.postBody?.content || {}) as IRegisterSubmitPayload;
    const functionUrl = requestBody.registerRequestAzureFunctionUrl;
    const secretName = requestBody.registerRequestAzureFunctionKeySecretName;

    const {
        registerRequestAzureFunctionUrl: _functionUrl,
        registerRequestAzureFunctionKeySecretName: _secretName,
        ...payloadWithoutConfig
    } = requestBody;

    const payload: Omit<
        IRegisterSubmitPayload,
        'registerRequestAzureFunctionUrl' | 'registerRequestAzureFunctionKeySecretName'
    > = payloadWithoutConfig;

    if (!functionUrl || !secretName) {
        throw new Error('Missing AzureFunctionUrl or AzureFunctionKeySecretName in submit request payload.');
    }

    const secret = await msdyn365Commerce?.secretManager?.getSecretValue(secretName, ctx.requestContext.apiSettings.baseUrl);

    if (!secret?.value) {
        console.error(`Failed to resolve Azure Function key secret: ${secretName}.`);
        throw new Error(`Failed to resolve Azure Function key secret: ${secretName}.`);
    }

    const response = await fetch(functionUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'x-functions-key': secret.value
        },
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText || `Azure Function call failed with status ${response.status}.`);
    }

    const contentType = response.headers.get('content-type') || '';
    const data = contentType.includes('application/json') ? ((await response.json()) as { [key: string]: unknown }) : undefined;

    return {
        success: true,
        message: 'Register request submitted successfully.',
        data
    };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<ISubmitRegisterRequestResponse>>action,
    id: 'PostRegisterRequest',
    input: createInput
});
